<template>
    <div class='container'>
    <b-jumbotron>
        <template v-slot:lead >
            <h4 v-html='CurrQuestion.question'></h4>
            
        </template>

        <hr class="my-4">
        <b-list-group>
            <b-list-group-item  
            v-for='(answer,index) in answers' 
            :key='index'
            @click='selectAnswer(index)'
            :class="selectClass(index)"
            v-html='answer'
            ></b-list-group-item>
        </b-list-group>
        <br>

        <b-button variant="primary"
        @click='submitAnswer'
        :disabled='selectedIndex===null || answered'
        >
        Submit</b-button> &nbsp;
        <b-button @click='next' variant="success" :disabled='index==questionsInput-1'>Next</b-button>
    </b-jumbotron>
    </div>
</template>

<script>
    import _ from 'lodash'
    export default {
        props:{
            CurrQuestion:Object,
            next:Function,
            increment:Function,
            totalAns:Number,
            index:Number,
            questionsInput:String,
        },
        data(){
            return{
                selectedIndex:null,
                correctIndex:null,
                shuffledAnswers:[],
                answered:false,
            }
        },
        methods:{
            selectAnswer: function(index){
                if(!this.answered){
                this.selectedIndex=index;
                }
            },
            shuffleAnswers:function(){
                let answers=[...this.CurrQuestion.incorrect_answers,this.CurrQuestion.correct_answer];
                this.shuffledAnswers=_.shuffle(answers);
                this.correctIndex=this.shuffledAnswers.indexOf(this.CurrQuestion.correct_answer);
            },
            submitAnswer:function(){
                let isCorrect=false;
                if(this.selectedIndex==this.correctIndex){
                    isCorrect=true;
                }
                this.answered=true;
                this.computeNext();
                this.increment(isCorrect);
            },
            selectClass:function(index){
                let classTobeGiven='';
                if(this.selectedIndex==index && !this.answered)
                {
                    classTobeGiven='selectedStyle';
                }
                else if(this.selectedIndex==index && this.answered && this.selectedIndex==this.correctIndex){
                    classTobeGiven='correctStyle';
                }
                else if(this.selectedIndex==index && this.answered && this.selectedIndex!=this.correctIndex){
                    classTobeGiven='wrongStyle';
                }
                
                if(this.answered && this.correctIndex==index){
                    classTobeGiven='correctStyle';
                }
                return classTobeGiven
            },
            computeNext:function(){
                if(this.index==this.totalAns){
                    return false;
                }
                else{
                    return true;
                }
            }
        },
        watch: {
            CurrQuestion: {
                immediate:true,
                handler(){
                    this.selectedIndex=null;
                    this.shuffleAnswers();
                    this.answered=false;
                    
                }
            },
            
        },
        computed:{
            answers:function(){
                let answers=[...this.CurrQuestion.incorrect_answers];
                answers.push(this.CurrQuestion.correct_answer);
                return answers;
            },
        },
    }
</script>
<style scoped>
    .list-group-item:hover{
        background-color:lightblue;
        cursor:pointer;
    }
    .selectedStyle{
        background-color:lightblue;
        
    }
    .correctStyle{
        background-color:lightgreen;
        
    }
    .wrongStyle{
        background-color:lightpink;
        
    }
</style>